// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_aee9e1f","oddsBoostHeader":"_91344bc","oddsBoostTitle":"_4a0c1c5","oddsBoostTitleText":"_60ff344","marketTemplateWrapper":"_7e06e14"};